import React from 'react';
import PullToRefreshBase from 'react-pull-to-refresh';

/**
 * Componente wrapper para react-pull-to-refresh que lida corretamente com as props
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Function} props.onRefresh - Função chamada quando o refresh é iniciado
 * @param {Function} props.onRefreshComplete - Função chamada quando o refresh é completado
 * @param {number} props.pullDownThreshold - Limiar para iniciar o refresh
 * @param {number} props.resistance - Resistência ao puxar
 * @param {number} props.distThreshold - Limiar de distância
 * @param {number} props.distMax - Distância máxima
 * @param {number} props.distReload - Distância para recarregar
 * @param {React.ReactNode} props.pullingContent - Conteúdo exibido durante o puxar
 * @param {React.ReactNode} props.refreshingContent - Conteúdo exibido durante o refresh
 * @param {string} props.className - Classes CSS adicionais
 * @param {React.ReactNode} props.children - Conteúdo do componente
 * @returns {JSX.Element} Componente React
 */
const PullToRefresh = ({
  onRefresh,
  onRefreshComplete,
  pullDownThreshold = 80,
  resistance = 2.5,
  distThreshold = 2,
  distMax = 3,
  distReload = 3,
  pullingContent,
  refreshingContent,
  className = '',
  children
}) => {
  // Props que serão passadas diretamente para o componente base
  const baseProps = {
    onRefresh,
    resistance,
    className
  };

  // Props que precisam ser convertidas para o formato esperado pelo componente base
  const convertedProps = {
    max: distMax,
    dist: distReload,
    threshold: pullDownThreshold,
    distThreshold,
    pullingContent: pullingContent || (
      <div className="flex justify-center items-center p-3 text-blue-500">
        <svg className="animate-pulse h-6 w-6 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
        </svg>
        <span>Puxe para atualizar</span>
      </div>
    ),
    refreshingContent: refreshingContent || (
      <div className="flex justify-center items-center p-3 text-blue-500">
        <svg className="animate-spin h-6 w-6 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>Atualizando...</span>
      </div>
    )
  };

  // Combinar todas as props
  const finalProps = {
    ...baseProps,
    ...convertedProps
  };

  return (
    <PullToRefreshBase {...finalProps}>
      {children}
    </PullToRefreshBase>
  );
};

export default PullToRefresh; 